// @flow
import styled from 'styled-components';
import { blackGrey, jetBlack } from '../../colors';
import { media } from '../..';
/*::
import type { Node, ComponentType } from 'react';

export type RichTextThemeType = {|
  Main: * => Node,
|};
*/

var thm
/*: RichTextThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-11gmpnd-0"
  })(["*{box-sizing:border-box;padding:0;margin:0;}p{font-size:2rem;font-weight:200;line-height:150%;color:", ";&:not(:last-child){margin-bottom:4rem;}}ul{margin-left:20px;}li{font-size:2rem;font-weight:200;line-height:150%;color:", ";margin-bottom:3.5rem;}h1,h2,h3,h4,h5,h6{margin-bottom:2rem;}h1{font-size:6.4rem;font-weight:200;line-height:8.2rem;", "{font-size:4.8rem;}}h2{font-size:4.8rem;font-weight:200;", "{font-size:3.6rem;}}h3{font-size:3.6rem;font-weight:200;}h4{font-size:2.6rem;font-weight:400;line-height:150%;}h5{font-size:1.8rem;font-weight:400;line-height:150%;}img{max-width:100%;}b,strong{font-weight:300;}a{color:", ";font-weight:300;&:visited,&:active{color:", ";}}"], blackGrey(), blackGrey(), media.sm, media.sm, jetBlack(), jetBlack())
};
export default thm;